import React, { useEffect, useState } from "react";
import {
  Modal as AntModal,
  Badge,
  Button,
  message,
  Popconfirm,
  Space,
  Pagination,
} from "antd";
import styled from "styled-components";
import {
  IconGlobe,
  IconArrowRight,
} from "../../../../assets/icons";
import api from "../../../../api/api";
import cartLogo from "../../../../assets/icons/logo.svg";
import DoubleCheckIcon from "../../../../assets/icons/double-check.svg";
import { useTranslation } from "react-i18next";

const Modal = styled(AntModal)`
  .ant-modal-title {
    font-size: 24px;
  }

  .ant-modal-header {
    margin-bottom: 16px;
  }

  .ant-modal-footer {
    display: none;
  }

  @media (max-width: 768px) {
    .ant-modal {
      max-width: calc(100vw - 24px);
      margin: 0 auto;
    }

    .ant-modal-content {
      padding: 18px;
      border-radius: 16px;
    }

    .ant-modal-title {
      font-size: 20px;
    }
  }
`;

const InfoText = styled.div`
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: 400;
  color: #1e1e1e;

  @media (max-width: 480px) {
    font-size: 14px;
    line-height: 1.5;
  }
`;

const ItemsWrapper = styled.div`
  margin-bottom: 24px;
`;
const ItemsGroup = styled.div`
  border: 1px solid #b9b9b9;
  border-radius: 16px;
  overflow: hidden;
`;

const ItemBox = styled.div`
  padding: 16px;
  display: flex;
  gap: 16px;
  align-items: center;
  border-bottom: 1px solid #e8e8e8;
  background: #fff;

  &:last-child {
    border-bottom: none;
  }

  .ant-btn {
    height: 40px;
    min-width: 140px;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const ItemBoxMobile = styled.div`
  padding: 16px;
  display: none;
  gap: 16px;
  align-items: flex-start;
  flex-direction: column;
  border-bottom: 1px solid #e8e8e8;
  background: #fff;

  &:last-child {
    border-bottom: none;
  }

  .ant-btn {
    height: 40px;
    width: 100%;
  }

  @media (max-width: 768px) {
    display: flex;
  }
`;
const ItemBoxTow = styled.div`
  padding: 16px;
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #b9b9b9;
  border-radius: 16px;
  margin: 20px 0 30px 0;
  background: #fff;

  .ant-space {
    min-width: 0;
  }
@media (max-width: 768px) {
    display: none;
  }
`;

const ItemBoxTowMobile = styled.div`
  padding: 16px;
  display: none;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #b9b9b9;
  border-radius: 16px;
  margin: 20px 0 30px 0;
  background: #fff;

  .ant-space {
    min-width: 0;
  }

 @media (max-width: 768px) {
    display: flex;
  }
`;

const BoldText = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: ${(props) => props.theme.primaryColor};
  word-break: break-word;

  @media (max-width: 480px) {
    font-size: 15px;
  }
`;

const LightText = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #686868;
  word-break: break-word;

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

const ConnectDomainModal = ({ isNew, open, handleClose, successCallback, connectedDomainData }) => {
  const [loading, setLoading] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [domains, setDomains] = useState([]);
  const [data, setData] = React.useState({});
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 5,
    totalCount: 0,
  });
  const [connectedDomain, setConnectedDomain] = useState(null);
  const [dataLoaded, setDataLoaded] = React.useState(false);

  const [t] = useTranslation();

  const fetchDomains = (page = 1) => {
    setLoading(true);
    api
      .getAvailableDomains({ page, page_size: pagination.pageSize })
      .then(({ data: { domain_records, pagination: pag } }) => {
        setDomains(domain_records);
        setPagination({
          page: pag.page,
          pageSize: pag.pageSize,
          totalCount: pag.totalCount,
        });
      })
      .catch((err) => message.error(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchDomains(pagination.page); }, [connectedDomainData]);

  const handleConnectClicked = ({ id, domain_UUID, domain_name }) => {
    if (!loading) {
      setLoading(true);
      setSelectedId(id);
      api[isNew ? "linkDomain" : "reLinkDomain"]({ domain_UUID, custom_domain: domain_name })
        .then(({ data }) => {
          setLoading(false);
          message.success("Connected successfully!");
          successCallback(data);
          setConnectedDomain(data);
          getAllDomain();
          fetchDomains(pagination.page);
        })
        .catch((err) => { setLoading(false); message.error(err); });
    }
  };

  const onCancel = () => !loading && handleClose();

   const getAllDomain = () => {
    api
      .getAllDomainData()
      .then(({ data }) => {
        setData(data);
      })
      .catch((error) => {
        message.error(error);
      });
  };

  useEffect(() => {
    Promise.all([getAllDomain(),]).finally(() => setDataLoaded(true));
  }, [connectedDomain,connectedDomainData]); 

  return (
    <Modal
  centered
  destroyOnClose
  open={open}
  width={800}
  title={t("privacy_protection")}
  onCancel={onCancel}
  footer={false}
  styles={{
    body: {
      maxHeight: "75vh",
      overflowY: "auto",
    },
  }}
>
      <InfoText>{t('to_publish_template')}</InfoText>

      <ItemsWrapper>
        {domains.length > 0 ? (
    <ItemsGroup>
      {domains.map((domain) => (
        <React.Fragment key={domain.id}>
          
          {/* Desktop */}
          <ItemBox>
            <IconGlobe />

            <Space direction="vertical" style={{ flex: 1 }}>
              <BoldText>{domain.domain_name}</BoldText>

              <Space wrap>
                <Badge status="success" text={t("available")} />
                <LightText>|</LightText>
                <LightText>
                  {t("purchased_from", {
                    register_from:
                      domain.domain_registration_from_project,
                  })}
                </LightText>
              </Space>
            </Space>

            <Popconfirm
              title={t("connect_domain")}
              description={t("are_you_sure_connect")}
              onConfirm={() => handleConnectClicked(domain)}
              okText={t("yes")}
              cancelText={t("no")}
            >
              <Button
                type="primary"
                loading={selectedId === domain.id && loading}
              >
                {t("connect_domain")}
              </Button>
            </Popconfirm>
          </ItemBox>

          {/* Mobile */}
          <ItemBoxMobile>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "12px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <IconGlobe />
                <BoldText>{domain.domain_name}</BoldText>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "6px",
                }}
              >
                <Badge status="success" text={t("available")} />

                <LightText>
                  {t("purchased_from", {
                    register_from:
                      domain.domain_registration_from_project,
                  })}
                </LightText>
              </div>
            </div>

            <Popconfirm
              title={t("connect_domain")}
              description={t("are_you_sure_connect")}
              onConfirm={() => handleConnectClicked(domain)}
              okText={t("yes")}
              cancelText={t("no")}
            >
              <Button
                type="primary"
                loading={selectedId === domain.id && loading}
                block
              >
                {t("connect_domain")}
              </Button>
            </Popconfirm>
          </ItemBoxMobile>
        </React.Fragment>
      ))}
    </ItemsGroup>
  )  : (
       <div
          style={{
            border: "1px solid #cecece",
            borderRadius: "10px",
            minHeight: "300px",
            padding: "24px",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            margin: "auto",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <img
            src={cartLogo}
            alt="cartlog"
            style={{
              borderRadius: "20px",
              width: "80px",
              height: "80px",
            }}
          />

          <h3
            style={{
              fontSize: "clamp(20px, 4vw, 28px)",
              color: "#000",
              margin: 0,
            }}
          >
            {t("looking_another")}
          </h3>

          <p
            style={{
              fontSize: "14px",
              color: "#8d8d8dff",
              textAlign: "center",
              margin: 0,
            }}
          >
            {t("purchase_on_onesite")}
          </p>

          <a
            href="https://www.onesitecart.com/services/purchase-domain"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              flexWrap: "wrap",
              justifyContent: "center",
            }}
          >
            <p
              style={{
                fontSize: "16px",
                color: "#1677ff",
                margin: 0,
              }}
            >
              {t("start_domain")}
            </p>

            <IconArrowRight />
          </a>
        </div>
        )}

        {/* Pagination */}
        {pagination.totalCount > pagination.pageSize && (
          <Pagination
            current={pagination.page}
            pageSize={pagination.pageSize}
            total={pagination.totalCount}
            onChange={(page) => { setPagination(prev => ({ ...prev, page })); fetchDomains(page); }}
            style={{ marginTop: 16, textAlign: "center" }}
          />
        )}
      </ItemsWrapper>

      {data && Object.keys(data).length > 0 && (
        <div>
          <InfoText>{t('domain_in_use')}</InfoText>
          <ItemBoxTow>
            <IconGlobe />
            <Space direction="vertical" style={{ flex: 1 }}>
              <BoldText>{data.domain_name}</BoldText>
              <Space>
                <Badge status="success" text={t('available')} />
                <LightText>|</LightText>
                <LightText>{`${t('purchased_from',{register_from:data.domain_registration_from_project })}`}</LightText>
              </Space>
            </Space>
            <div style={{ height: "40px", display: "flex", alignItems: "center", gap: "10px" }}>
              <img src={DoubleCheckIcon} alt="double-check" style={{ width: "18px", height: "16px" }} />
              <h3 style={{ fontSize: "16px", color: "#1677ff", fontWeight: 600 }}>{t('in_use')}</h3>
            </div>
          </ItemBoxTow>
           <ItemBoxTowMobile>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            ><div style={{display:"flex", justifyContent:"space-between",alignItems:"center",width:"100%"}}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <IconGlobe />
                <BoldText>{data.domain_name}</BoldText>
                 </div>
                  <div style={{ height: "40px", display: "flex", alignItems: "center", gap: "10px" }}>
              <img src={DoubleCheckIcon} alt="double-check" style={{ width: "18px", height: "16px" }} />
              <h3 style={{ fontSize: "16px", color: "#1677ff", fontWeight: 600 }}>{t('in_use')}</h3>
            </div>
             
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "6px",
                }}
              >
                <Badge status="success" text={t("available")} />

                <LightText>
                  {t("purchased_from", {
                    register_from:
                      data.domain_registration_from_project,
                  })}
                </LightText>
              </div>
            </div>
          
          </ItemBoxTowMobile>
        </div>
      )}
    </Modal>
  );
};

export default ConnectDomainModal;
